module.exports = __webpack_public_path__ + "img/product-showcase-gallery-01.6b7c7f1f.jpg";